var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"background":"var(--bg3)"}},[_vm._v(" 待分配项目 "),_c('div',[_vm._v("待关联")])])
}]

export { render, staticRenderFns }